import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import "./styles/theme.css";
import { BrowserRouter } from "react-router-dom";
import AppContextProvider from "./context/AppContextProvider";
import App from "./pages/App/App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import "@emran-alhaddad/saudi-riyal-font/index.css";
import "./bootstrap/echo";
import { installSingleActionGuard } from "./utils/singleActionGuard";
import { installPaginationScrollToTop } from "./utils/tablePagination";

installSingleActionGuard();
installPaginationScrollToTop();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>,
);
